// extracted by mini-css-extract-plugin
export default {"container":"container_b0uNn","titleContainer":"titleContainer_MsOFl","title":"title_hY4l3","list":"list_WEwGT","item":"item_BCui5","buttons":"buttons_J0EuA"};